<template>
  <div class="e-simple-content e-scroll-container">
    <VuePerfectScrollbar class="e-content__inner">
      <div class="e-content__scroll">
        <div class="e-module e-module--limited e-module--left">
          <Loading v-if="loading" />

          <header v-if="content.title && !loading" class="e-module__head">
            <h1>{{ content.title }}</h1>
          </header>
          <div
            v-if="content.body && !loading"
            class="e-module__body"
            v-html="content.body"
          />
        </div>
      </div>
    </VuePerfectScrollbar>
  </div>
</template>

<script>
import api from 'api'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import Loading from 'atoms/Loading/Loading'

export default {
  components: {
    Loading,
    VuePerfectScrollbar
  },

  data: () => ({
    content: {},
    loading: false
  }),

  watch: {
    $route: function() {
      this.getContent()
    }
  },
  created() {
    this.getContent()
  },
  methods: {
    getContent: async function() {
      this.loading = true
      this.content = {}

      try {
        const response = await api.call(
          'getContent',
          this.$route.params.contentName
        )
        this.content = {
          title: this.$t(response.data.title),
          body: response.data.body
        }
      } catch (error) {
        this.$error(error)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
